export const BotanicalAccent = () => (
  <svg viewBox="0 0 160 240" className="w-32 h-48 text-base-200" fill="none" aria-hidden="true">
    <path
      d="M80 230 C80 230,16 160,16 96 C16 48,48 8,80 8 C112 8,144 48,144 96 C144 160,80 230,80 230Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="80"
      y1="8"
      x2="80"
      y2="230"
      stroke="currentColor"
      strokeWidth="1"
      strokeDasharray="4 5"
    />
    <path d="M80 65 C80 65,48 56,32 40" stroke="currentColor" strokeWidth="1" />
    <path d="M80 65 C80 65,112 56,128 40" stroke="currentColor" strokeWidth="1" />
    <path d="M80 110 C80 110,42 96,22 76" stroke="currentColor" strokeWidth="1" />
    <path d="M80 110 C80 110,118 96,138 76" stroke="currentColor" strokeWidth="1" />
    <path d="M80 158 C80 158,46 142,28 122" stroke="currentColor" strokeWidth="1" />
    <path d="M80 158 C80 158,114 142,132 122" stroke="currentColor" strokeWidth="1" />
  </svg>
)
